function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email_at") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 208a7.741 7.741 0 0 1-3.1-.63 8.06 8.06 0 0 1-4.27-4.27 7.967 7.967 0 0 1 0-6.21 8.087 8.087 0 0 1 4.27-4.26 7.967 7.967 0 0 1 6.21 0 8.115 8.115 0 0 1 4.26 4.26A7.719 7.719 0 0 1 112 200v1.25a2.741 2.741 0 0 1-2.756 2.75 2.485 2.485 0 0 1-1.3-.354 3.329 3.329 0 0 1-1.01-.937 4.333 4.333 0 0 1-1.344.948A3.994 3.994 0 1 1 108 200v1.25a1.25 1.25 0 1 0 2.5 0V200a6.511 6.511 0 1 0-6.5 6.5h4v1.5zm0-5.5a2.49 2.49 0 1 0-1.771-.729 2.411 2.411 0 0 0 1.771.729z",
    transform: "translate(-92 -188)",
    style: {
      fill: "#758091"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAt);
export default __webpack_public_path__ + "static/media/email_at.83f0ad3f8aca69947740ba5b7be770c5.svg";
export { ForwardRef as ReactComponent };